<template>
  <div class="signup" :class="{'app-content' : isbefore}">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 px-0 nav-tab-custom">
          <b-tabs content-class="px-3 bg-gray pt-1" fill active-nav-item-class="nav-custom" >
            <b-tab :title="this.$i18n.t('message.solved_problem')" active>
              <div class="container bg-gray pt-mobile-0">
                <div class="row mt-3 mx-2 pb-2">
                  <div class="col-12">
                    <router-link :to="'/mypage'">
                      <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
                    </router-link>
                    <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
                    <router-link :to="'/pastedQuizList'">
                      <p class="text-dark font14 under" style="display: inline;">{{$t("message.industry_id_"+ occupation)}}{{$t("message.of_solved_problem")}}</p>
                    </router-link>
                  </div>
                </div>
                <div class="row mt-4 mx-2">
                  <div class="col-12">
                    <h5 class="font16"><b>{{$t("message.industry_id_"+ occupation)}}{{$t("message.of_solved_problem_list")}}</b></h5>
                    <p class="">{{$t("message.industry_id_"+ occupation)}}{{$t("message.solved_description") }}</p>
                  </div>
                </div>
                <div class="row mt-4 mx-2 pb-4 pt-2 pt-mobile-0" v-if="examinations.length != 0">
                  <div class="col-12 col-md-6 col-lg-3 mb-4 pt-mobile-0"  v-for="examination in examinations" :key="examination.id">
                    <b-card class="text-center">
                      <h5 class="text-center font16"><b>{{$t("message.test_result")}}({{ format_day(examination.created_at) }})</b></h5>
                      <p class="mb-0 text-gray">{{$t("message.before_result")}} : {{corrects[examination.id] + $t("message.score")}} </p>
                      <b-button  class="next mt-4 py-2 px-4" @click="move_question(examination)" > {{$t("message.looking_back")}}</b-button>
                    </b-card>
                  </div>
                </div>

                <div class="row mt-4 mx-2" v-else>
                  <div class="col-12 mb-4 mx-4">
                    <b-card class="text-center">
                      <h5>{{$t("message.no_problem")}}</h5>
                      <b-button  class="next mt-4 py-2 px-4 text-white">
                        <router-link :to="'./quiz'" >
                          <p class="text-white mb-0">{{$t("message.do_problem")}}</p>
                         </router-link>
                       </b-button>
                   </b-card>
                   </div>
                </div>

              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import axios from 'axios';
export default {
  components: {
  },
  data () {
    return {
      occupation:undefined,
      idToken: localStorage.idToken,
      examinations: [],
      corrects: {},
      isbefore: true
    }
  },
  methods: {
    move_question(examination){
      this.$router.replace('./pastedQuiz/'+ examination.id)
    },
    format_day(d){
      return moment(d).format("YYYY.MM.DD HH:mm")
    },
    async get_any_info(){
      await axios
      .get(process.env.VUE_APP_API + "/trial_examination",{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.examinations = response.data
        this.examinations.forEach(examination =>
          axios
          .get(process.env.VUE_APP_API + "/trial_examination/" + examination.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(result => {
            if(result.data.trial_examination.results == null){
              this.corrects[examination.id] = 0
            }else{
              this.corrects[examination.id] = result.data.trial_examination.results
            }
            this.corrects = Object.assign({}, this.corrects)
            this.examinations = Object.assign({}, this.examinations)

          }).catch(() => {

          })
        )
      }).catch(error => {
        console.log('this is error', error)
      })
    }
  },
  async mounted(){
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.occupation = this.memberInfo.current_industry
    await this.get_any_info()
    this.$store.commit('setLoading', false)
    this.isbefore = false

  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user
    })
  },
  watch:{
    async memberInfo(val){
      this.$store.commit('setLoading', true)
      this.occupation = val.current_industry
      await this.get_any_info()
      this.$store.commit('setLoading', false)
    }
  },

}
</script>

<style scoped>
.nav-tab-custom{
  border-top: 2px solid #E5E5E5 !important;
}
.nav-tab-custom /deep/ .nav-custom{
  color:rgba(1, 1, 20, 0.87);
  background-color: #fff !important;
  border-color: #fff #fff #fff;
  border-bottom:  2px solid #000054 !important;

}
.nav-tab-custom /deep/ .a-black{
  color:rgba(1, 1, 20, 0.87);
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}


</style>
